export default "__VITE_ASSET__CoGoF4IF__"